module.exports = __webpack_public_path__ + "img/关于宏邦3.58f53b16.jpg";